<template>
  <SectionSplit
    class="StatementsDelay"
    src="../../assets/landing-landowners/plants.jpg">
    <h3>
      {{ $t("title") }}
    </h3>
    <p
      v-for="(paragraph, index) in $t('paragraphs')"
      :key="index"
      v-html="paragraph" />
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: { SectionSplit },
}
</script>

<style lang="scss">
.StatementsDelay {
  .body {
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Due to delay in publishing annual financial statements of UAB Sun Investment Group",
    "paragraphs": [
      "SIG informs of a slight delay in the presentation of our financial statements for fiscal year 2024. Due to objective circumstances, UAB Sun Investment Group will not be able to timely publish the audited consolidated and individual financial statements for the fiscal year 2024. The delay is related to organizational matters, therefore the audit of certain material Group companies took longer than expected impacting in the timeline. We anticipate the financial statements will be available no later than June 30, 2025.",
      "We understand this delay may cause inconvenience, and we apologize for any disruption it may cause. As usual, we are fully committed to provide complete and clear financial information.",
      "For any questions or further information, please contact <a href=\"mailto:corp.relations@suninvestmentgroup.com\" target=\"_blank\">corp.relations@suninvestmentgroup.com</a>",
      "Nasdaq link: <a href=\"https://view.news.eu.nasdaq.com/view?id=1359362&lang=en\" target=\"_blank\">Due to the convened meeting of bondholders of Sun Investment Group UAB</a>"
    ]
  },
  "lt": {
    "title": "Dėl vėlavimo skelbiant UAB „Sun Investment Group“ metines finansines ataskaitas",
    "paragraphs": [
      "Informuojame, kad UAB „Sun Investment Group“ šiek tiek vėluoja pateikti 2024 finansinių metų finansines ataskaitas. Dėl objektyvių aplinkybių įmonė negalės laiku paskelbti audituotų konsoliduotų ir individualių 2024 metų finansinių ataskaitų. Vėlavimas susijęs su organizaciniais klausimais – kai kurių svarbių Grupės įmonių auditas užtruko ilgiau nei tikėtasi, o tai turėjo įtakos bendram grafiko laikymuisi. Tikimės, kad finansinės ataskaitos bus paskelbtos ne vėliau kaip 2025 m. birželio 30 d.",
      "Suprantame, kad šis vėlavimas gali sukelti nepatogumų, ir atsiprašome už bet kokius sutrikimus. Kaip visada, esame įsipareigoję teikti išsamią ir skaidrią finansinę informaciją.",
      "Jeigu turite klausimų ar reikia daugiau informacijos, prašome kreiptis el. paštu: <a href=\"mailto:corp.relations@suninvestmentgroup.com\" target=\"_blank\">corp.relations@suninvestmentgroup.com</a>",
      "Nasdaq nuoroda: <a href=\"https://view.news.eu.nasdaq.com/view?id=1359362&lang=lt\" target=\"_blank\">Dėl šaukiamo Sun Investment Group UAB obligacijų savininkų susirinkimo</a>"
    ]
  }
}
</i18n>
